import {Injectable} from '@angular/core';
import {MxGridCustomizerEvent, MxGridProps} from './mx-grid-customizer-event';

export interface GridPropsService {
    // TODO should be exact fields, do not use BoGridProps
    readonly props: Readonly<MxGridProps>;

    setRowQueryParams(rowQueryParams: Array<{[k: string]: any}>): void;
}

@Injectable()
export class MxGridPropsService implements GridPropsService {

    // TODO move allowReorder to OrderService
    // TODO should be exact fields, do not use BoGridProps
    private _props: MxGridProps = new MxGridProps();

    get props(): Readonly<MxGridProps> {
        return  this._props;
    }

    constructor() {
    }

    public setUp(event: MxGridCustomizerEvent): void {
        this._props = event.gridProps;
    }

    // TODO may be, it should be moved to other service...
    public setRowQueryParams(rowQueryParams: Array<{[k: string]: any}>): void {
        this._props.rowQueryParams = rowQueryParams;
    }
}

